import { css } from "@emotion/core";
import { mq } from "../../../../cssInJs";

export default {
  controls: css(
    mq({
      marginBottom: "1rem",
    //   padding: "1rem 0",
    //   borderBottom: "1px solid #e0e0e0",
    //   backgroundColor: "#f8f9fa",
    //   borderRadius: "8px",
    //   boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      transition: "all 0.3s ease-in-out",
    })
  ),

  filters: css(
    mq({
      display: "flex",
      alignItems: "center",
    })
  ),

  dropdownButton: css(
    mq({
      minWidth: "150px",
      textAlign: "left",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    })
  ),

  viewToggle: css(
    mq({
      display: "flex",
      alignItems: "center",
      "& .btn": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "8px 16px",
        transition: "all 0.2s ease-in-out",
        border: "1px solid #ccc",
        fontWeight: "500",
        "&:hover": {
          transform: "translateY(-1px)",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        },
        "&.btn-primary": {
          backgroundColor: "#fff",
          borderColor: "#000",
          color: "#000",
          "& img": {
            filter: "none", 
          }
        },
        "&.btn-outline-primary": {
          backgroundColor: "transparent",
          borderColor: "#000",
          color: "#000",
          "& img": {
            filter: "none", // Original color for outline buttons
          },
          "&:hover": {
            backgroundColor: "#fff",
            color: "#000",
            "& img": {
              filter: "none", 
            }
          }
        },
        "& img": {
          width: "16px",
          height: "16px",
          marginRight: "6px",
          transition: "filter 0.2s ease-in-out",
          verticalAlign: "middle",
        }
      }
    })
  ),

  contentContainer: css(
    mq({
      minHeight: "80vh",
      position: "relative",
      // overflow: "hidden",
    })
  ),

  contentView: css(
    mq({
      width: "100%",
      height: "100%",
      opacity: 0,
      transform: "translateY(20px)",
      transition: "all 0.3s ease-in-out",
      "&.active": {
        opacity: 1,
        transform: "translateY(0)",
      }
    })
  ),

  atdwMap: css(
    mq({
      width: "100%",
      height: "80vh",
      position: "relative",
    })
  ),

  searchView: css(
    mq({
      width: "100%",
      minHeight: "80vh",
      position: "relative",
    })
  ),

  popupBackground: css(
    mq({
      position: "fixed",
      top: "0",
      left: "0",
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0,0,0,0.5)",
      zIndex: "9998",
    })
  ),

  container: css(
    mq({
      position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: "white",
      padding: "2rem",
      borderRadius: "8px",
      boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
      zIndex: "9999",
      maxWidth: "500px",
      width: "90%",
    })
  ),

  popupTitle: css(
    mq({
      fontSize: "1.5rem",
      fontWeight: "bold",
      marginBottom: "0.5rem",
      color: "#333",
    })
  ),

  popupTown: css(
    mq({
      fontSize: "1rem",
      marginBottom: "0.5rem",
      color: "#666",
    })
  ),

  popupDesc: css(
    mq({
      fontSize: "0.9rem",
      lineHeight: "1.4",
      marginBottom: "1.5rem",
      color: "#555",
    })
  ),
}; 